import { ChartData } from '../data/ChartData';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataType } from '../data/ChartDataType';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { ColumnBarRenderer } from './ColumnBarRenderer';

export class ColumnRenderer extends ColumnBarRenderer {
  constructor(
    gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    private data: ChartDataArray,
    hasComparison: boolean,
    private hasSecondaryData: boolean,
    public secondaryAxis?: boolean,
    private secondaryAsLine?: boolean
  ) {
    super(gElement, data, hasComparison);
  }

  public render(x: d3.ScaleBand<string>, y: d3.ScaleLinear<number, number>, limit?: number) {
    const basePadding: number =
      ColumnRenderer.PADDING +
      (this.hasComparison ? ColumnRenderer.COMPARISON_EXTRA : 0) +
      (this.hasSecondaryData ? ColumnRenderer.SECONDARY_EXTRA : 0);

    const barSpace: number = x.bandwidth() - basePadding;

    const barWidth: number =
      Math.min(ColumnRenderer.MAX_BAR_WIDTH, barSpace / (this.hasSecondaryData ? 2 : 1)) +
      (this.data.isComparison ? ColumnRenderer.COMPARISON_EXTRA : 0);

    const xAdjustment =
      x.bandwidth() / 2 +
      (!this.data.isSecondary
        ? !this.hasSecondaryData
          ? -barWidth / 2
          : -barWidth - ColumnRenderer.SECONDARY_EXTRA / 2
        : ColumnRenderer.SECONDARY_EXTRA / 2);

    const zeroY = y(0);
    // primary and not comparison case
    const handlers: ColumnBarChartAttrHandler = {
      x: (d: ChartData): number => x(d.label!)! + xAdjustment,
      y: (d: ChartData): number => Math.min(y(d.value!), zeroY),
      height: (d: ChartData): number => Math.abs(zeroY - y(d.value!)),
      width: (): number => barWidth,
      class: (d: ChartData): string => [this.className || '', d.color || ''].join(' '),
    };

    if (ChartDataType.primary === this.data.type && this.data.isPlan) {
      handlers.x = (d: ChartData) => x(d.label!)!;
      handlers.y = (d: ChartData) => y(d.value!) - 1;
      handlers.width = () => x.bandwidth();
      if (this.hasSecondaryData && !this.secondaryAsLine) {
        handlers.width = () => x.bandwidth() / 2;
      }
      handlers.height = () => 2;
    } else if (ChartDataType.secondary === this.data.type && this.data.isPlan) {
      handlers.x = (d: ChartData) => x(d.label!)! + x.bandwidth() / 2;
      handlers.y = (d: ChartData) => y(d.value!)! - 1;
      handlers.width = () => x.bandwidth() / 2;
      handlers.height = () => 2;
    }

    super.renderInternal(this.data, handlers, limit);
  }

  public switchHighlight(_index: number, _highlight: boolean) {}
}
